import { Component, OnDestroy, OnInit } from '@angular/core';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';
import { DataService } from 'projects/runner/src/app/services/data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-video-conference-container',
  templateUrl: './video-conference-container.component.html',
  styleUrls: ['./video-conference-container.component.scss']
})
export class VideoConferenceContainerComponent implements OnInit, OnDestroy {

  public ac: AcModel = null;
  public acSubscription: Subscription = null;

  constructor(
    private data: DataService,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
    }
  }

  public openConference(): void {
    if (this.ac?.conference_url) {
      window.open(this.ac.conference_url);
    }
  }

}
